module.exports = __webpack_public_path__ + "img/_0.0cc06467.png";